import * as React from 'react';
import Box from '@mui/material/Box';

import Modal from '@mui/material/Modal';
// import { Stack } from '@mui/system';
// import { height } from '@mui/system';
import { Viewer, Worker } from '@react-pdf-viewer/core';
// import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import { IoClose } from "react-icons/io5";
import { Typography } from '@mui/material';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';




export default function ImageModal(props) {


  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    height: props.fileType === 'pdf' ? '90vh' : "auto",
    objectFit: 'contain',
    overflow: 'scroll',
    bgcolor: 'background.paper',
    border: '0px solid #000',
    boxShadow: 24,
    // display: 'flex',
    // justifyContent: 'center',
    // alignItems: 'center',
    p: 4,
    maxHeight: '90vh'
  };

  const pageNavigationPluginInstance = pageNavigationPlugin();
  const zoomPluginInstance = zoomPlugin();
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  return (
    <>
      <Modal
        open={props.open}
        // onClose={props.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box sx={
            {
              position: 'absolute',
              top: 10,
              right: 10,
              fontSize: '24px',
              cursor: 'pointer'
            }
          } onClick={props.handleClose}>{<IoClose />}</Box>
          <Typography sx={{ position: 'absolute', top: 5, left: 5, zIndex: 2 }}>{props.fileType}</Typography>

          {
            props.fileType === 'pdf' ?
              <Worker workerUrl='https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js'>
                <div style={{ height: '100%', overflow: 'auto' }}>
                  <Viewer
                    fileUrl={props.image}
                    plugins={[pageNavigationPluginInstance, zoomPluginInstance, defaultLayoutPluginInstance]}
                  />
                </div>
              </Worker>
              :
              <div
                style={{
                  height: '100%',
                  width: '100%',
                  overflow: 'auto',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <img
                  src={props.image}
                  alt="img"
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                  }}
                />
              </div>


          }

        </Box>
      </Modal>
    </>
  );
}
